import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DatePicker } from '../../date-picker/date-picker';
import {
    DATE_LIST,
    REPORT_LIST,
    SKILL_QUESTS_MASTERY,
    ACTIVITY_MASTERY
} from '../filter-constants';
import dropdownDataSelectors from '../redux/dropdown-data/dropdown-data-selectors';
import dropdownDataActions from '../redux/dropdown-data/dropdown-data-actions';
import { dateFilterPropType, filterPropType } from '../filter-prop-types';
import {
    DEFAULT_DATE_OPTIONS_OBJ,
    THIS_SCHOOL_YEAR_OBJ,
    CUSTOM_DATE_OBJ,
    LIFETIME_OBJ
} from '../../date-picker/components/date-picker-trans/date-picker-constants';

export class DateDropdown extends PureComponent {
    static propTypes = {
        dateDropdownData: PropTypes.shape({
            selectedOption: dateFilterPropType
        }),
        reportDropdownData: PropTypes.shape({
            selectedOption: filterPropType
        }),
        className: PropTypes.string,
        academicYear: PropTypes.shape({
            startDate: PropTypes.string,
            endDate: PropTypes.string
        }),
        setSelectedDate: PropTypes.func,
        handleApplyFilters: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            options: DEFAULT_DATE_OPTIONS_OBJ,
            selectedReportType: null
        };
    }

    componentWillReceiveProps(newProps) {
        this.manageSelectedReportType(newProps);
        this.manageOptions(this.props, newProps);
    }

    manageSelectedReportType = (newProps) => {
        const { reportDropdownData: newReportDropdownData } = newProps;
        const { selectedReportType } = this.state;

        if (selectedReportType !== newReportDropdownData.selectedOption) {
            this.setState({
                selectedReportType: newReportDropdownData.selectedOption
            });
        }
    };

    /**
     * Skill quests mastery report type only has 2 options compared to all other report types which have
     * 4. This function helps manage those options and overrides current selection if it doesnt exist
     * in SQM options list searching from other report type.
     */
    manageOptions = (props, newProps) => {
        const { reportDropdownData: prevReportDropdownData } = props;
        const {
            reportDropdownData,
            dateDropdownData,
            academicYear,
            hasLifetimeData
        } = newProps;
        const prevSelectedOption = prevReportDropdownData.selectedOption.value;
        const currentSelectedOption = reportDropdownData.selectedOption.value;

        // We don't need to change anything if we stay within the SQM report
        if (prevSelectedOption === currentSelectedOption) return;

        switch (reportDropdownData.selectedOption.value) {
            case SKILL_QUESTS_MASTERY: {
                const selectedDateType = dateDropdownData.selectedOption.type;
                this.manageSkillQuestMasterOverride(
                    selectedDateType,
                    academicYear,
                    hasLifetimeData,
                    currentSelectedOption
                );
                break;
            }
            default: {
                const options = this.manageLifetimeDate(
                    DEFAULT_DATE_OPTIONS_OBJ,
                    hasLifetimeData,
                    currentSelectedOption
                );
                this.setState({
                    options
                });
            }
        }
    };

    manageSkillQuestMasterOverride = (
        selectedDateType,
        academicYear,
        hasLifetimeData,
        currentSelectedOption
    ) => {
        let options = [THIS_SCHOOL_YEAR_OBJ, CUSTOM_DATE_OBJ];
        options = this.manageLifetimeDate(
            options,
            hasLifetimeData,
            currentSelectedOption
        );
        const containsValidOption = options.includes(selectedDateType);

        if (!containsValidOption) {
            this.props.setSelectedDate({
                type: THIS_SCHOOL_YEAR_OBJ.value,
                startDate: academicYear.startDate,
                endDate: academicYear.endDate
            });
        }

        this.setState({
            options
        });
    };

    manageLifetimeDate = (options, hasLifeTimeData, currentSelectedOption) => {
        if (hasLifeTimeData && currentSelectedOption === ACTIVITY_MASTERY) {
            return [...options, LIFETIME_OBJ];
        }

        return options;
    };

    dateChanged = (type, startDate, endDate) => {
        this.props.setSelectedDate({ type, startDate, endDate });
        this.props.handleApplyFilters();
    };

    /**
     * ON REPORT TYPE: Skills Quest Mastery
     * When custom date option is selected, the start date is pre-populated with the first day of
     * the academic year and the end date can be chosen by the teacher, meaning the results will
     * be shown from the first day of the academic year up until the end date.
     */
    getInitialDateProp = () => {
        const { academicYear } = this.props;
        const { selectedReportType } = this.state;

        if (
            selectedReportType &&
            selectedReportType.value === SKILL_QUESTS_MASTERY
        ) {
            return {
                startDate: academicYear.startDate,
                endDate: academicYear.endDate
            };
        }

        return null;
    };

    render() {
        const { dateDropdownData, className, academicYear } = this.props;
        const { selectedOption } = dateDropdownData;
        const { options } = this.state;

        return (
            <div className={className}>
                <DatePicker
                    academicYear={academicYear}
                    currentDate={selectedOption}
                    initialDate={this.getInitialDateProp()}
                    onDateChange={this.dateChanged}
                    options={options}
                />
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        dateDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            DATE_LIST
        )(state),
        reportDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            REPORT_LIST
        )(state),
        academicYear: state.academicYear,
        hasLifetimeData: state.hasLifetimeData
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        { setSelectedDate: dropdownDataActions.setSelectedDate },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(DateDropdown);



// WEBPACK FOOTER //
// ./components/report-filters/dropdown-menus/date-dropdown.js